import React from 'react';
import { Link as GatsbyLink } from 'gatsby-theme-localization';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { useTranslation } from 'react-i18next';
import { ROUTE_MAP } from 'navigation/route-map';

const Link = ({ children, to, onClick, className, style, rel, target }) => {
  const [_, i18n] = useTranslation();
  const lang = i18n.language;

  function localizeTo(key: string, thislang: string) {
    const localized = ROUTE_MAP[thislang][key];

    if (!localizeTo) return '/';

    return localized;
  }

  // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  const internal = /^[A-Z]*$/.test(to);

  // Use gatsby-link for internal links, and <OutboundLink> for others
  if (internal || onClick) {

    if (onClick) {
      return (
        <GatsbyLink
          className={className}
          style={style}
          onClick={onClick}
          prefixLanguage={lang !== 'sv'}
        >
          {children}
        </GatsbyLink>
      )
    }
    return (
      <GatsbyLink
        className={className}
        style={style}
        to={localizeTo(to, lang)}
        prefixLanguage={lang !== 'sv'}
      >
        {children}
      </GatsbyLink>
    );
  }
  return (
    <OutboundLink
      style={{ textDecoration: 'none' }}
      href={to}
      onClick={onClick}
      target={target}
      rel={rel}
    >
      <span className={className}>{children}</span>
    </OutboundLink>
  );
};

export default Link;
